module.exports = __webpack_public_path__ + "static/img/dj_loop_01.8329734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dj/dj_loop_01.png
// module id = TS1z
// module chunks = 1